module.exports = __webpack_public_path__ + "static/media/flooring_gwp_10y_y.8b74c98b.csv";